import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Update({ open, onClose, category, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    nom: '',
    type_categorie: null,
    private: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (!category) return;
    setFormData({
      nom: category.nom,
      type_categorie: category.type_categorie?.id ?? null,
      private: Number(category.private) === 0,
      user_id: user?.id,
    });
    setErrors({});
  }, [category, user?.id]);

  if (!open || !category) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${APP_API_URL}/categories/${category.id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data.message || 'Les modifications ont été enregistrées avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs et réessayer.',
        });
      } else {
        console.error("Erreur lors de l'envoi du formulaire", error);
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Une erreur est survenue. Veuillez réessayer plus tard.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title={`Modifier — ${category.nom}`}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose} disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            form={`update-category-form-${category.id}`}
            className="duo-btn duo-btn--primary"
            disabled={isLoading}
          >
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id={`update-category-form-${category.id}`} onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor={`update-category-nom-${category.id}`} className="duo-form-label">
            Nom de la catégorie *
          </label>
          <input
            type="text"
            className="duo-input"
            id={`update-category-nom-${category.id}`}
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="private"
              checked={formData.private}
              onChange={handleChange}
            />
            <span>
              Catégorie active
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour rendre la catégorie inactive.
              </span>
            </span>
          </label>
          {errors.private && <p className="text-danger small mt-1 mb-0">{errors.private[0]}</p>}
        </div>
      </form>
    </DuoModal>
  );
}
